// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class ProjectDocumentNestedResource extends Resource {
    basePath: string = 'project/project/{parent}/documents/';

    objectPath: string = 'project/project/{parent}/documents/{ident}/';

    create(parentId: string, data: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getBasePath(parentId)}`,
            'POST', data, { 'Content-Type': 'multipart/form-data' },
        ).then((response) => response.data);
    }
}
